import { render, staticRenderFns } from "./BidAdministration.vue?vue&type=template&id=71dd8c6c&"
import script from "./BidAdministration.vue?vue&type=script&lang=js&"
export * from "./BidAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports